// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { PrimaryTemplate } from 'components/templates/PrimaryTemplate';
import StorageLocationRegistrationScreen from 'components/organisms/StorageLocationRegistration';
import { useTranslation } from 'react-i18next';

const StorageLocationRegistration = () => {
  const { t } = useTranslation();

  return (
    <PrimaryTemplate h1={t('storage_location_registration.title')}>
      <StorageLocationRegistrationScreen />
    </PrimaryTemplate>
  );
};

export default StorageLocationRegistration;
